module.exports = __webpack_public_path__ + "static/media/bell-icon.38cf59cb.svg";